import { Injectable } from "@angular/core";
import { GameTabManager } from "./game-tab-manager.interface";

@Injectable({ providedIn: "root" })
export class ElectronGameTabManager extends GameTabManager {
    openOrFocus(gameTabName: string, oldGameTabName?: string) {
        return window.electron.ipcRenderer.invoke('open-or-focus-table', gameTabName, oldGameTabName);
    }

    close(gameTabName: string) {
        window.electron.ipcRenderer.invoke('close-table', gameTabName);
    }
}
